import React from 'react'
import { Form } from 'ui/organisms'

export default function StorageLogin() {
  return (
    <Form method="post" action="https://uas2.uilogin.de/login">
      <Form.Row className="mb-1">
        <Form.Col className="col-md-5 mb-1 mb-md-0">
          <Form.Input name="serviceID" value="cloud.eue" type="hidden" />
          <Form.Input name="username" placeholder="E-Mail-Adresse oder Nutzername" required />
        </Form.Col>
        <Form.Col className="col-md-5 mb-1 mb-md-0">
          <Form.Input name="password" type="password" placeholder="Passwort" required />
          <Form.Input name="login" value="Weiter" type="hidden" />
        </Form.Col>
        <Form.Col className="col-md-2 ">
          <Form.Button type="submit" text="Weiter" small block primary />
        </Form.Col>
      </Form.Row>
    </Form>
  )
}
